import EOverlay from 'components/others/EOverlay';
import { escapeHtml } from 'utils/helpers/functions/escapeHtml';

interface GenerationLogCommentCellProps {
    generationComment?: string;
    proposalEmailBody?: string;
    generationTitle: string;
    emailBodyTitle: string;
}

const toOverlayHtml = (value?: string) =>
    value ? `<div>${escapeHtml(String(value || ''))}</div>` : '';

const GenerationLogCommentCell = ({
    generationComment,
    proposalEmailBody,
    generationTitle,
    emailBodyTitle,
}: GenerationLogCommentCellProps) => {
    const generationText = String(generationComment || '').trim();
    const emailBodyText = String(proposalEmailBody || '').trim();

    return (
        <div className="proposal-comment-icons d-inline-flex align-items-center justify-content-center gap-2">
            <span className="proposal-comment-icon-wrap" title={generationTitle}>
                <EOverlay text={toOverlayHtml(generationText)} />
            </span>
            <span className="proposal-comment-icon-wrap" title={emailBodyTitle}>
                <EOverlay text={toOverlayHtml(emailBodyText)} iconClass="bi-envelope" />
            </span>
        </div>
    );
};

export default GenerationLogCommentCell;
